import { render, staticRenderFns } from "./BaseCaptcha.vue?vue&type=template&id=4312d1da&"
import script from "./BaseCaptcha.vue?vue&type=script&lang=js&"
export * from "./BaseCaptcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports